import { type NavigateFn, useNavigate } from "@tanstack/react-router";
import { proxy, useSnapshot } from "valtio";

export const newTestRunDialogState = proxy({
  show: false,
  preShow: false,
  preselectedKeys: [] as number[],
});

export function navigateAndShowTestRunDialog({
  navigate,
  location,
  preselectedKeys,
}: {
  navigate: NavigateFn;
  location: Location;
  preselectedKeys?: number[];
}) {
  newTestRunDialogState.show = true;
  newTestRunDialogState.preselectedKeys = preselectedKeys || [];
  if (location.pathname !== "/runs") {
    navigate({ to: "/runs", state: { href: { to: "/runs" } } });
  }
}

export function useNewTestRunDialog() {
  const navigate = useNavigate();
  const state = useSnapshot(newTestRunDialogState);

  return {
    ...state,
    setShow(flag: boolean) {
      newTestRunDialogState.show = flag;
      newTestRunDialogState.preselectedKeys = [];
    },
    navigateAndShow(_from?: string) {
      navigateAndShowTestRunDialog({ location, navigate });
    },
  };
}
